import React, { useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from 'react-router-dom';

import { useAppContext } from "../AppContext";
import Select from 'react-select';

import AsyncSelect from 'react-select/async'
import CONFIG from "../config";

const options = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' },
];

function AppointmentForm({
  appointmentTypes,
  appointmentType,
  setAppointmentType,
  selectedSlot,
  selectedDate,
  selectedStartTime,
  selectedEndTime,
  handleManualSlotChange
}) {
  const navigate = useNavigate();
  const { state } = useAppContext();

  const [selectTime, setSelectTime] = useState("");
  const [selectDate,setSelectDate] = useState("");

  const [selectedOption,setSelectedOption] = useState("");

//   useEffect(() => {
//     if (!selectedStartTime) return;
//     selectTime = selectedStartTime;
// }, [selectedStartTime]);


  const [formData, setFormData] = useState({
    firstName: state?.patientInfo?.first_name,
    lastName:state?.patientInfo?.last_name,
    mobilePhone: "",
    email: state?.patientInfo?.email,
    areaOfConcern: "",
    consent: false
  });




  const SaveAppointment = async (e) => {
    e.preventDefault();

    const appointmentData = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      mobilePhone: formData.mobilePhone,
      email: formData.email,
      // areaOfConcern: formData.areaOfConcern,
      // appointmentType: appointmentType,
      appointmentDate: selectedDate,
      startTime: selectedStartTime,
      //endTime: selectedEndTime,
      consent: false
    };

    console.log("Appointment Data:", appointmentData);

    try {
      const response = await fetch(
        "https://64rt4awzn3.execute-api.us-east-1.amazonaws.com/dev/createappointment",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(appointmentData)
        }
      );

      if (!response.ok) {
        throw new Error("Failed to save appointment");
      }

      const result = await response.json();

      console.log("Appointment saved:", result);

      alert("Appointment booked successfully!");
    } catch (error) {
      console.error("Error saving appointment:", error);
      alert("Unable to book appointment.");
    }
  };




async function doBookAppointment() {
  const reason   = "Primary Care";
  const type     = "";
  const date     = selectedDate;
  const time     = selectedStartTime;
  const provider = "";
  
  try {
    const pid = state?.patientId;
    if (!pid) throw new Error("Could not identify patient — check Debug tab");
    const r = await invokeLambda(CONFIG.lambdaAppointment, {
      action:"create", patient_id:pid,
      reason, appointment_type:type,
      preferred_date:selectDate, preferred_time:selectTime||"09:00",
      provider_name:provider||"Next Available Provider",
      channel:"web-portal",
    });
    if (r && r.booked) {
       navigate('/patient-dashboard');
    } else {
      
    }
  } catch(err) {  }
  finally {  }
}



  async function invokeLambda(fn, payload) {
    const url = `https://lambda.${CONFIG.region}.amazonaws.com/2015-03-31/functions/${fn}/invocations`;
    const body = JSON.stringify(payload);

    const headers = await signRequest("POST", url, body);
    const res = await fetch(url, { method: "POST", headers, body });
    const text = await res.text();
    let result; try { result = JSON.parse(text); } catch { result = text; }
    if (res.status !== 200) {
      console.log(`✗ Lambda HTTP ${res.status}`, result);
      throw new Error(`HTTP ${res.status}: ${text.slice(0, 200)}`);
    }
    if (result && result.errorMessage) {
      console.log(`✗ Lambda function error`, result);
      throw new Error(result.errorMessage);
    }

    return result;
  }

  async function signRequest(method, url, body) {
    const c = state.awsCreds;
    const p = new URL(url);
    const now = new Date();
    const dt = now.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
    const ds = dt.slice(0, 8);
    const ph = await sha256hex(body);
    const ch = `content-type:application/json\nhost:${p.host}\nx-amz-date:${dt}\nx-amz-security-token:${c.sessionToken}\n`;
    const sh = "content-type;host;x-amz-date;x-amz-security-token";
    const cr = [method, p.pathname, "", ch, sh, ph].join("\n");
    const sc = `${ds}/us-east-1/lambda/aws4_request`;
    const ss = ["AWS4-HMAC-SHA256", dt, sc, await sha256hex(cr)].join("\n");
    let sk = await hmac("AWS4" + c.secretAccessKey, ds);
    sk = await hmac(sk, "us-east-1"); sk = await hmac(sk, "lambda"); sk = await hmac(sk, "aws4_request");
    const sig = Array.from(new Uint8Array(await hmac(sk, ss))).map(b => b.toString(16).padStart(2, "0")).join("");
    return {
      "Content-Type": "application/json", "X-Amz-Date": dt, "X-Amz-Security-Token": c.sessionToken,
      "Authorization": `AWS4-HMAC-SHA256 Credential=${c.accessKeyId}/${sc}, SignedHeaders=${sh}, Signature=${sig}`
    };
  }

  async function hmac(key, msg) {
    const k = typeof key === "string" ? new TextEncoder().encode(key) : key;
    const ck = await crypto.subtle.importKey("raw", k, { name: "HMAC", hash: "SHA-256" }, false, ["sign"]);
    return new Uint8Array(await crypto.subtle.sign("HMAC", ck, new TextEncoder().encode(msg)));
  }

  async function sha256hex(msg) {
    const h = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(msg));
    return Array.from(new Uint8Array(h)).map(b => b.toString(16).padStart(2, "0")).join("");
  }



  const handleChangeSelect = (selectedOption) => {
    // this.setState({ selectedOption }, () =>
    //   console.log(`Option selected:`, this.state.selectedOption)
    // );
  };


   const loadOptions = async (inputValue) => {
    if (!inputValue) return [];

    // try {
    //   const response = await axios.get(
    //     `/api/provider/search?keyword=${inputValue}`
    //   );

    //   return response.data.map((item) => ({
    //     value: item.id,
    //     label: item.name
    //   }));
    // } catch (error) {
    //   console.error(error);
    //   return [];
    // }
  };



  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  return (
    // <form className="form" onSubmit={SaveAppointment}>
    <div>
      {selectedSlot && (
        <div className="info-note">
          <strong>Selected Slot : </strong>
          {moment(selectedSlot.start).format("MMM D, h:mm A")} –{" "}
          {moment(selectedSlot.end).format("MMM D, h:mm A")}
        </div>
      )}

      {/* Patient Info Section */}
      <div className="form-section">
        <h3 className="section-label-small">Patient Information</h3>
        <div>
            <AsyncSelect
      cacheOptions
      defaultOptions
      loadOptions={loadOptions}
      onChange={handleChangeSelect}
      placeholder=""
    />
        </div>
        

        <div className="form-group spaced">
          <label className="form-label">First Name</label>
          <input
            type="text"
            name="firstName"
            className="form-control"
            placeholder="first name"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group spaced">
          <label className="form-label">Last Name</label>
          <input
            type="text"
            name="lastName"
            className="form-control"
            placeholder="last name"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </div>

        {/* <div className="form-group spaced">
          <label className="form-label">Mobile Phone</label>
          <input
            type="text"
            name="mobilePhone"
            className="form-control"
            placeholder="mobile"
            value={formData.mobilePhone}
            onChange={handleChange}
            required
          />
        </div> */}

        <div className="form-group spaced">
          <label className="form-label">Email Address</label>
          <input
            type="email"
            name="email"
            className="form-control"
            placeholder="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
      </div>

      {/* Appointment Details */}
      <div className="form-section mt-3">
        {/* <div className="form-group spaced">
          <label className="form-label">Area of Concern</label>
          <input
            type="text"
            name="areaOfConcern"
            className="form-control"
            placeholder="Describe briefly"
            value={formData.areaOfConcern}
            onChange={handleChange}
            required
          />
        </div> */}

        {/* <div className="form-group spaced">
          <label className="form-label">Appointment Type</label>

          <select
            className="form-control  form-select"
            value={appointmentType}
            onChange={(e) => setAppointmentType(e.target.value)}
            required
          >
            <option value="">Select type</option>

            {appointmentTypes.map((type, idx) => (
              <option key={idx} value={type}>
                {type}
              </option>
            ))}
          </select>
        </div> */}

        <div className="row g-2">
          <div className="col-md-6">
            <div className="form-group spaced">
              <label className="form-label">Preferred Date</label>

              <input
                type="date"
                className="form-control"
                value={selectedDate}
                onChange={(e) =>{
                  setSelectDate(e.target.value);
                  handleManualSlotChange(
                    e.target.value,
                    selectedStartTime,
                    selectedEndTime
                  )
                  console.log(e.target.value);
                }
                }
                required
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group spaced">
              <label className="form-label">Start Time</label>

              {/* <input
                type="time"
                className="form-control"
                value={selectedStartTime}
                onChange={(e) =>
                  handleManualSlotChange(
                    selectedDate,
                    e.target.value,
                    selectedEndTime
                  )
                }
                required
              /> */}

 <select
        id="book-time"
        value={selectTime} className="form-select"
        onChange={(e) => setSelectTime(e.target.value)}
      >
        <option value="">Select Time</option>
        <option value="09:00">9:00 AM</option>
        <option value="09:30">9:30 AM</option>
        <option value="10:00">10:00 AM</option>
        <option value="10:30">10:30 AM</option>
        <option value="11:00">11:00 AM</option>
        <option value="11:30">11:30 AM</option>
        <option value="12:00">12:00 PM</option>
        <option value="12:30">12:30 PM</option>
        <option value="13:00">1:00 PM</option>
        <option value="13:30">1:30 PM</option>
        <option value="14:00">2:00 PM</option>
        <option value="14:30">2:30 PM</option>
        <option value="15:00">3:00 PM</option>
        <option value="15:30">3:30 PM</option>
        <option value="16:00">4:00 PM</option>
        <option value="16:30">4:30 PM</option>
      </select>


              
            </div>
          </div>

          {/* <div className="col-md-4">
            <div className="form-group spaced">
              <label className="form-label">End Time</label>

              <input
                type="time"
                className="form-control"
                value={selectedEndTime}
                onChange={(e) =>
                  handleManualSlotChange(
                    selectedDate,
                    selectedStartTime,
                    e.target.value
                  )
                }
                required
              />
            </div>
          </div> */}
        </div>
      </div>

      {/* Consent */}
      {/* <div className="form-group mb-3 mt-3">
        <label className="flex-center gap-8">
          <input
            type="checkbox"
            name="consent"
            checked={formData.consent}
            onChange={handleChange}
            required
          />

          I consent to receive text messages
        </label>
      </div> */}

      {/* Submit */}
      <button type="submit" className="btn btn-success w-100" onClick={doBookAppointment} >
        Book Appointment
      </button>

      </div>
  );
}

export default AppointmentForm;